"use strict";

exports.__esModule = true;
exports.DsCard = void 0;
require("./DsCard.css");
var _jsxRuntime = require("react/jsx-runtime");
var DsCard = exports.DsCard = function DsCard(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$customColSize = _ref.customColSize,
    customColSize = _ref$customColSize === void 0 ? 'col-12 col-lg-6 col-xl-4' : _ref$customColSize,
    _ref$customMargin = _ref.customMargin,
    customMargin = _ref$customMargin === void 0 ? 'mb-4' : _ref$customMargin,
    _ref$rowMode = _ref.rowMode,
    rowMode = _ref$rowMode === void 0 ? false : _ref$rowMode,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ds-card " + (rowMode ? 'ds-card--row' : '') + " " + customColSize + " d-flex",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "card card-raising " + customMargin + " w-100 " + color,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "card-body",
        children: children
      })
    })
  });
};